import { Injectable, inject } from '@angular/core';
import { combineLatest, map, Observable } from 'rxjs';
import { FilterSelectItem } from '../../../components/checkbox-facette/checkbox-liste/filterSelectItem';
import { AggregationKey } from '../../../model/aggregations';
import { KostenBezeichnungWithBoundary, orderedKostenBezeichnung } from '../../../model/kosten';
import { FacettenService } from '../facetten.service';
import { KostenUrlService } from './kostenurl.service';

@Injectable({
  providedIn: 'root'
})
export class KostenService extends FacettenService {
  constructor() {
    const kostenUrlService = inject(KostenUrlService);

    super(kostenUrlService, AggregationKey.Kosten, orderedKostenBezeichnung);
  }

  public override getSelectItems$(): Observable<FilterSelectItem[]> {
    return combineLatest([
      this.getFacetteOptions$(),
      this.facettenUrlService.selectedOptionIds$
    ]).pipe(
      map(([facetteOptions, ids]) => {
        return (this.orderedOptions as KostenBezeichnungWithBoundary[]).map(
          ({ id, bezeichnung, ariaLabel, backendId }) => {
            const anzahl =
              facetteOptions.find((option) => option.id === backendId.toString())?.anzahl ?? 0;
            const isSelected = this.isItemSelected(ids, backendId.toString());
            const item = {
              key: id.toString(),
              ariaLabel: ariaLabel,
              treffer: anzahl,
              label: bezeichnung,
              selected: isSelected,
              active: anzahl > 0
            };
            return item;
          }
        );
      })
    );
  }
}
